export default function Layout({ children }) {
  return (
    <>
      <main>{children}</main>
    </>
  )
}
